import { IClock as IClockBase, clock } from '@deltasierra/shared';

export const SID = 'clock';

// Hack to re-expose IClock interface from this module
export type IClock = IClockBase;

angular.module('app').service(SID, [() => clock]);
